var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      ref: "btnSelectProfessional",
      staticClass: "btn btn-info",
      attrs: { id: _vm.professional.id },
      on: {
        click: function($event) {
          return _vm.setSelectedProfessional(_vm.professional)
        }
      }
    },
    [
      _vm.professional.is_favorited_user
        ? [
            _c("i", {
              staticClass: "fas fa-bolt -status-instant-book -button"
            }),
            _vm._v(
              "\n    " + _vm._s(_vm.$t("message.button.instant_book")) + "\n  "
            )
          ]
        : [_vm._v("\n     " + _vm._s(_vm.$t("message.button.book")) + " \n  ")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70b97478", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b97478","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/ButtonSelectProfessional.vue
// module id = 1877
// module chunks = 0